import { useState, useEffect } from 'react';
import BackButton from '../components/BackButton';
import api from '../api';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';

export default function KsefSettings() {
  const [loading, setLoading] = useState(true);
  const { t } = useI18n();
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    ksef_token: '',
    ksef_env: 'test',
    ksef_auto_send: false,
  });
  const [tokenSet, setTokenSet] = useState(false);

  useEffect(() => { loadSettings(); }, []);

  async function loadSettings() {
    try {
      const res = await api.get('/ksef/settings');
      setForm({
        ksef_token: '',
        ksef_env: res.data.ksef_env || 'test',
        ksef_auto_send: res.data.ksef_auto_send || false,
      });
      setTokenSet(res.data.ksef_token_set);
    } catch (e) {
      if (e.response?.status !== 403) {
        setMsg('❌ ' + (e.response?.data?.detail || 'Ошибка загрузки'));
      }
    }
    setLoading(false);
  }

  async function save() {
    setSaving(true);
    setMsg('');
    try {
      const payload = {
        ksef_env: form.ksef_env,
        ksef_auto_send: form.ksef_auto_send,
      };
      if (form.ksef_token) payload.ksef_token = form.ksef_token;
      await api.put('/ksef/settings', payload);
      setMsg('✅ Настройки KSeF сохранены');
      if (form.ksef_token) setTokenSet(true);
      setForm(f => ({ ...f, ksef_token: '' }));
    } catch (e) {
      setMsg('❌ ' + (e.response?.data?.detail || e.message));
    }
    setSaving(false);
  }

  async function testConnection() {
    setTesting(true);
    setMsg('');
    try {
      const res = await api.post('/ksef/test-connection');
      setMsg('✅ ' + (res.data.message || 'Подключение успешно'));
    } catch (e) {
      setMsg('❌ ' + (e.response?.data?.detail || 'Ошибка подключения'));
    }
    setTesting(false);
  }

  if (loading) return <Loading />;

  return (
    <div className="page">
      <BackButton />
      <h1>🔑 Настройки KSeF</h1>
      <p style={{ opacity: 0.7, fontSize: 14, marginBottom: 16 }}>
        Krajowy System e-Faktur — интеграция для отправки фактур в систему МФ Польши
      </p>

      <div className="form">
        {/* Token */}
        <div className="field">
          <label>Токен API KSeF {tokenSet && <span style={{ color: '#10b981' }}>✓ установлен</span>}</label>
          <input
            type="password"
            value={form.ksef_token}
            onChange={e => setForm({ ...form, ksef_token: e.target.value })}
            placeholder={tokenSet ? '••••••• (оставьте пустым чтобы не менять)' : 'Вставьте токен KSeF'}
            style={{
              padding: '12px',
              borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'rgba(255,255,255,0.05)',
              color: '#fff',
              width: '100%',
            }}
          />
        </div>

        {/* Environment */}
        <div className="field">
          <label>Среда</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              className={`btn btn-small ${form.ksef_env === 'test' ? 'btn-primary' : ''}`}
              onClick={() => setForm({ ...form, ksef_env: 'test' })}
              style={{ flex: 1 }}
            >
              🧪 Тестовая
            </button>
            <button
              className={`btn btn-small ${form.ksef_env === 'prod' ? 'btn-primary' : ''}`}
              onClick={() => setForm({ ...form, ksef_env: 'prod' })}
              style={{ flex: 1 }}
            >
              🏭 Продуктовая
            </button>
          </div>
          <small style={{ opacity: 0.5, marginTop: 4, display: 'block' }}>
            {form.ksef_env === 'test' ? 'ksef-test.mf.gov.pl' : 'ksef.mf.gov.pl'}
          </small>
        </div>

        {/* Auto-send toggle */}
        <div className="field" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <label style={{ flex: 1, margin: 0 }}>Авто-отправка в KSeF</label>
          <div
            onClick={() => setForm({ ...form, ksef_auto_send: !form.ksef_auto_send })}
            style={{
              width: 48,
              height: 28,
              borderRadius: 14,
              background: form.ksef_auto_send ? '#10b981' : 'rgba(255,255,255,0.2)',
              position: 'relative',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >
            <div style={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              background: '#fff',
              position: 'absolute',
              top: 3,
              left: form.ksef_auto_send ? 23 : 3,
              transition: 'left 0.2s',
            }} />
          </div>
        </div>
      </div>

      {msg && (
        <div style={{
          marginTop: 12,
          padding: 12,
          borderRadius: 8,
          background: msg.includes('✅') ? 'rgba(16,185,129,0.2)' : 'rgba(239,68,68,0.2)',
          fontSize: 14,
        }}>
          {msg}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        <button className="btn btn-primary" onClick={save} disabled={saving} style={{ flex: 1 }}>
          {saving ? '⏳ Сохранение...' : '💾 Сохранить'}
        </button>
        {tokenSet && (
          <button className="btn btn-secondary" onClick={testConnection} disabled={testing} style={{ flex: 1 }}>
            {testing ? '⏳ Проверка...' : '🔌 Тест подключения'}
          </button>
        )}
      </div>
    </div>
  );
}
